import type { SxProps, Theme } from '@mui/material/styles'

type NotificationListStyleMap = {
    loadingContainer: SxProps<Theme>
    list: SxProps<Theme>
    content: SxProps<Theme>
    contentHeader: SxProps<Theme>
    deleteButton: SxProps<Theme>
}

export const notificationListStyles: NotificationListStyleMap = {
    loadingContainer: { display: 'flex', justifyContent: 'center', py: 4 },
    list: { display: 'flex', flexDirection: 'column' },
    content: { flex: 1, minWidth: 0, px: 1.5, py: 1.5, pr: 4 },
    contentHeader: { display: 'flex', alignItems: 'baseline', gap: 1, justifyContent: 'space-between' },
    deleteButton: { position: 'absolute', bottom: 4, right: 4, color: 'error.main', p: 0.5 },
}

export const getNotificationItemStyles = (isRead: boolean, isLink: boolean): SxProps<Theme> => ({
    position: 'relative',
    display: 'flex',
    alignItems: 'stretch',
    cursor: isLink ? 'pointer' : 'default',
    bgcolor: isRead ? 'transparent' : 'primary.50',
    '&:hover': isLink ? { bgcolor: 'grey.50' } : {},
    '&:not(:last-child)': { borderBottom: '1px solid', borderBottomColor: 'divider' },
})

export const getNotificationReadToggleStyles = (isRead: boolean): SxProps<Theme> => ({
    width: 4,
    flexShrink: 0,
    bgcolor: isRead ? 'grey.200' : 'primary.main',
    cursor: 'pointer',
    transition: 'background-color 0.15s',
    '&:hover': { bgcolor: isRead ? 'grey.400' : 'primary.dark' },
})

export const getNotificationTypeIconStyles = (isRead: boolean): SxProps<Theme> => ({
    mt: 1.5,
    ml: 1.5,
    color: isRead ? 'text.secondary' : 'primary.main',
    flexShrink: 0,
})

export const getNotificationTitleStyles = (): SxProps<Theme> => ({
    flex: 1,
    minWidth: 0,
})

export const getNotificationTimestampStyles = (): SxProps<Theme> => ({
    flexShrink: 0,
})

export const getNotificationMessageStyles = (): SxProps<Theme> => ({
    display: 'block',
})
